import http from '../../utils/fetch';
export default {
    baseurl:'/api/swyl/v1/dailyClear/userDailyClear',
    baseurl2:'/api/swyl/v1',

    //日清列表
    page(query){
        return http({
            url: this.baseurl+'/selectPage',
            method: 'post',
            params: query
        });
    },
    checkPage(query){
        return http({
            url: this.baseurl+'/checkPage',
            method: 'post',
            params: query
        });
    },
    getDailyPlan(query){
        return http({
            url: this.baseurl+'/getDailyPlan',
            method: 'post',
            params: query
        });
    },

    //导出Excel
    export(query){
        return http({
            url: this.baseurl+'/userCarePlan/downloadExcel',
            method: 'post',
            params: query
        });
    },
}
